module.exports = __webpack_public_path__ + "img/hdzb2.94984616.png";